import { render, staticRenderFns } from "./kw_card_default.vue?vue&type=template&id=30c86912&scoped=true&"
import script from "./kw_card_default.vue?vue&type=script&lang=js&"
export * from "./kw_card_default.vue?vue&type=script&lang=js&"
import style0 from "./kw_card_default.vue?vue&type=style&index=0&id=30c86912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c86912",
  null
  
)

component.options.__file = "kw_card_default.vue"
export default component.exports